import React, { Fragment } from 'react';
import { graphql } from 'gatsby';

import { buildUseCaseQuery } from './common/url';

import { Teaser } from './index/teaser';
import { UseCases } from './index/use-cases';
import { SuccessFactors } from './index/success-factors';
import { SampleProjects } from './index/sample-projects';
import { Testimonials } from './index/testimonials';
import { Customers } from './index/customers';

const Index = ({
	data: {
		markdownRemark: {
			frontmatter: {
				teaser,
				use_cases,
				success_factors,
				sample_projects,
				testimonials,
				featured_customers,
			},
		},
		projectsPage: { path: projectsPagePath },
	},
}) => {
	const useCaselinkGenerator = (useCase) =>
		`${projectsPagePath}${buildUseCaseQuery(useCase)}`;

	return (
		<Fragment>
			<Teaser data={teaser} />
			<UseCases data={use_cases} linkGenerator={useCaselinkGenerator} />
			<SuccessFactors data={success_factors} />
			<SampleProjects data={sample_projects} />
			<Testimonials data={testimonials} />
			<Customers data={featured_customers} />
		</Fragment>
	);
};

export const indexQuery = graphql`
	query templatesIndexQuery($remarkId: String!, $locale: String!) {
		markdownRemark(id: { eq: $remarkId }) {
			frontmatter {
				teaser {
					content
					link {
						url
						label
					}
					video {
						url
						title
					}
				}

				use_cases {
					header
				}

				success_factors {
					header
					items {
						title
						text
					}
				}

				sample_projects {
					header
					items
					link {
						url
						label
					}
				}

				testimonials {
					header
					items {
						name
						position
						quote
						image {
							file {
								childImageSharp {
									gatsbyImageData(
										width: 50
										height: 50
										layout: CONSTRAINED
										transformOptions: { cropFocus: ENTROPY }
									)
								}
							}
							title
							alt
						}
					}
				}

				featured_customers {
					header
					items
					link {
						url
						label
					}
				}
			}
		}

		projectsPage: sitePage(
			context: { locale: { eq: $locale }, key: { eq: "projects" } }
		) {
			path
		}
	}
`;

export default Index;
